import { inject, injectable } from "@launchtray/tsyringe-async";
import { IEmailVerificationPopupController } from "./IEmailVerificationPopupController";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";
import { IAuthModel } from "../../models/IAuthModel";
import { IContextResolver } from "../../../../../composition/IContextResolver";
import { SceneManager } from "../../../../../../scene/SceneManager";
import { ValidationFailedPopupScene } from "../../validationfailedpopup/ValidationFailedPopupScene";
import { Redirector } from "../../../../../../tools/Redirector";
import { IGuestModel } from "../../../../common/models/IGuestModel";

@injectable()
export class CreateWalletVerificationPopupController implements IEmailVerificationPopupController {
    private readonly contextResolver: IContextResolver;
    private readonly authModel: IAuthModel;
    private readonly guestModel: IGuestModel;
    private readonly web3Model: Web3Model;
    private readonly sceneManager: SceneManager;

    public constructor(
        @inject("IContextResolver") contextResolver: IContextResolver,
        @inject("IAuthModel") authController: IAuthModel,
        @inject("IGuestModel") guestModel: IGuestModel,
        web3Model: Web3Model,
        sceneManager: SceneManager
    ) {
        this.contextResolver = contextResolver;
        this.authModel = authController;
        this.guestModel = guestModel;
        this.web3Model = web3Model;
        this.sceneManager = sceneManager;
    }

    public openIntercom(email: string): void {
        Redirector.openIntercom(email, Date.now(), this.guestModel.name.value, this.guestModel.id.value); 
    }

    public async resendCode(email: string): Promise<void> {
        await this.web3Model.requestVerificationCode(email);
    }

    public async showValidationFailedPopup(): Promise<void> {
        const scene = await this.contextResolver.resolve(ValidationFailedPopupScene);
        await this.sceneManager.showViewableAsync(scene);
    }

    public async signWithCode(email: string, code: string): Promise<boolean> {
        if (this.web3Model.connected.value) {
            return await this.authModel.createWalletAuth();
        }
        if (await this.web3Model.createWallet(email, code)) {
            return await this.authModel.createWalletAuth();
        }
        return false;
    }
}